export enum REPORTING_VIEW_TYPES {
  PORTFOLIO = "portfolio",
  BUILDING = "building",
}

export enum REPORTING_TAB_TYPES {
  TOTAL = "total",
  INDIVIDUAL = "individual",
}

export enum REPORTING_TABLE_UNIT {
  WEIGHT = "WEIGHT",
  EMISSIONS = "EMISSIONS",
  COST = "COST",
}

export enum ReportingSortingDirection {
  ASC = "ASC",
  DESC = "DESC",
}
